<template>
  <div class="container">
    <div class="left">
      <div class="plus">
        <div class="list">
          <div>角色列表</div>
          <i class="el-icon-plus" @click="handList"></i>
        </div>
        <div class="width">
          <el-input
            size="small"
            placeholder="角色名称"
            prefix-icon="el-icon-search"
            v-model="users.role_name"
            clearable
            @clear="clear"
          >
            <el-button
              slot="append"
              @click="handLeIput"
              :disabled="!users.role_name"
              >搜索</el-button
            >
          </el-input>
        </div>
        <div class="scroll">
          <li
            class="iocn"
            v-for="item in roleData"
            :key="item.id"
            :class="[active == item.id ? 'iconnfon  ' : ' background']"
            @click="permissionsData(item.id)"
          >
            <div>
              <i class="el-icon-user"
                ><span class="list-left">{{ item.name }}</span></i
              >
            </div>
            <el-dropdown v-if="item.id == index && item.name != '系统管理员'">
              <span class="el-icon-more-outline"> </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  icon="el-icon-edit-outline"
                  @click.native="handEdit(item)"
                  >编辑</el-dropdown-item
                >
                <el-dropdown-item
                  icon="el-icon-delete"
                  @click.native="handDeta(item.id)"
                  >删除</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </li>
        </div>
      </div>

      <div class="br"></div>
    </div>
    <div class="right">
      <!-- <div class="flex">
        <div>
          {{ name}}<span v-if="usenameData != 0">({{ usenameData.length }})</span>
        </div>
      </div>
      <div class="flex list">
        <div class="usename" v-for="ite in usenameData" :key="ite.id">
          {{ ite.name }}
        </div>
      </div> -->
      <div class="distance">权限设置</div>
      <div style="width: 100%; margin: 20px">
        <el-checkbox
          v-model="checkAllFalse"
          :disabled="name === '系统管理员'"
          :indeterminate="isIndeterminate"
          @change="handleCheckAllChangeFalse"
          style="margin: 0 20px"
          >全选</el-checkbox
        >
        <el-checkbox
          v-model="checkedFalse"
          @change="expandAll"
          style="margin: 0 20px"
          >展开全部</el-checkbox
        >
      </div>
      <div style="overflow-y: auto; height: 720px">
        <el-tree
          :data="organizationData"
          ref="organizationData"
          show-checkbox
          :default-expand-all="true"
          node-key="id"
          :default-checked-keys="checkedData"
          :props="defaultProps"
          @check="handleNodeClick"
          @current-change="handleNodeChange"
        >
        </el-tree>
      </div>

      <!-- <div class="content">
        <el-checkbox
          v-if="name !== '系统管理员'"
          :indeterminate="isIndeterminate"
          v-model="checkAll"
          @change="handleCheckAllChange"
          >全选</el-checkbox
        >
        <div class="margin"></div>
        <el-checkbox-group v-model="value" @change="handleCheckedCitiesChange">
          <el-checkbox
            :disabled="name === '系统管理员'"
            class="distance-left"
          
            v-for="ite in citiesData"
            :key="ite.id"
            :label="ite.id"
            >{{ ite.name }}</el-checkbox
          >
        </el-checkbox-group>
      </div> -->
    </div>

    <el-dialog
      :title="title"
      :visible.sync="Popup"
      width="30%"
      modal
      destroy-on-close
      @close="close"
      append-to-body
    >
      <el-form
        class="login-form"
        label-position="top"
        label-width="80px"
        :model="modify"
        :rules="rules"
        ref="modify"
      >
        <el-form-item prop="name">
          <el-input placeholder="请输入角色" v-model="modify.name"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handClickCancel">取 消</el-button>
        <el-button type="primary" v-if="flag" @click="handClickConfirm"
          >确 定</el-button
        >
        <el-button type="primary" v-if="show" @click="handClickfirm"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "Member_role",
  data() {
    var validatePass = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("角色不能为空"));
      }
      let regex = /^[a-zA-Z\u4e00-\u9fa5]+$/;
      if (!regex.test(value)) {
        return callback(new Error("角色不能为数字"));
      } else {
        callback();
      }
    };
    return {
      flag: false,
      show: false,
      isIndeterminate: true,
      checkAll: false,
      cities: [],
      Popup: false,
      name: "",
      active: "",

      value: [],
      users: {
        role_name: "", //搜索关键字
      },
      usenameData: [],
      title: "",
      modify: {
        id: "",
        name: "",
      },
      rolesuser: {
        role_id: "",
        permission_ids: "",
      },

      permissions: {
        id: "",
      },
      roleData: [],
      rules: {
        name: [{ validator: validatePass, trigger: "blur" }], //部门校验
      },
      citiesData: [],
      listData: [],
      checkedData: [],
      listLength: "",
      checkAllFalse: false,
      checkedFalse: true,
      // 可以根据接口返回数据展示
      organizationData: [],
      // children和label 与接口字段保持一致
      defaultProps: {
        children: "cate_permissions",
        label: "name",
        disabled: this.disabledFn,
      },
    };
  },

  created() {
    this.rolesData();
  },

  methods: {
    disabledFn() {
      if (this.name === "系统管理员") {
        return true;
      }
    },
    async handleNodeClick(val) {
      console.log(val);
      let node = this.$refs.organizationData.getHalfCheckedKeys();
      let mode = this.$refs.organizationData.getCheckedKeys();
      let modelItem = node.concat(mode);
      console.log(modelItem.length, this.listLength);

 
      if (modelItem.length) {
        console.log(666)
        this.checkAllFalse = false;
        this.isIndeterminate = true;
      }else {
        console.log(444)
        this.checkAllFalse = false;
        this.isIndeterminate = false;
      }
       if ((modelItem.length - this.listLength) == this.listData.length) {
             console.log(333)
        this.isIndeterminate = false;
        this.checkAllFalse = true;
      }
      this.rolesuser.permission_ids = node.concat(mode).join();
      const res = await this.$axios.postListData(
        "admin/role-permissions",
        this.rolesuser
      );
      // if (this.checkedData.length == this.listData.length) {
      //       this.isIndeterminate = false;
      //       this.checkAllFalse= true;
      //     } else if(this.checkedData.length) {
      //       this.checkAllFalse= false;
      //     this.isIndeterminate = true;
      //     }else{
      //       this.checkAllFalse= false;
      //      this.isIndeterminate = false;
      //     }
      if (res.code == 200) {
      }
    },
    handleNodeChange(val) {
      console.log(val);
    },
    expandAll() {
      if (this.checkedFalse) {
        for (var i in this.$refs.organizationData.store.nodesMap) {
          this.$refs.organizationData.store.nodesMap[i].expanded = true;
        }
      } else {
        for (var j in this.$refs.organizationData.store.nodesMap) {
          this.$refs.organizationData.store.nodesMap[j].expanded = false;
        }
      }
    },
    async handleCheckAllChangeFalse(val) {
   
      // if (this.checkAllFalse) {
      //     this.$refs.organizationData.setCheckedNodes(this.organizationData);
      // } else {
      //     this.$refs.organizationData.setCheckedKeys([]);
      // }
      this.rolesuser.permission_ids = "";
      if (this.checkAllFalse) {
        // 设置
        this.$refs.organizationData.setCheckedNodes(this.organizationData);
        for (
          var i = 0;
          i < this.$refs.organizationData.getCheckedNodes().length;
          i++
        ) {
          this.rolesuser.permission_ids +=
            this.$refs.organizationData.getCheckedNodes()[i].id + ",";
        }
        this.rolesuser.permission_ids =
          this.rolesuser.permission_ids.slice(
            0,
            this.rolesuser.permission_ids.length - 1
          ) + "";
      let meta =  this.rolesuser.permission_ids.split(',');
       if((meta.length -this.listLength) ==this.listData.length){
        this.isIndeterminate = false;
          this.checkAllFalse = true;
       }


        const res = await this.$axios.postListData(
          "admin/role-permissions",
          this.rolesuser
        );
        if (res.code == 200) {
        }
      } else {
        this.$refs.organizationData.setCheckedNodes([]);
        this.rolesuser.permission_ids = "";
        const res = await this.$axios.postListData(
          "admin/role-permissions",
          this.rolesuser
        );
        if (res.code == 200) {
        }
      }
    },
    //角色列表
    handList() {
      this.cities = [];
      this.Popup = true;
      this.title = "添加角色";
      this.flag = true;
      this.show = false;
    },
    handLeIput() {
      let regex = /^[a-zA-Z\u4e00-\u9fa5]+$/;
      if (regex.test(this.users.role_name)) {
        this.rolesData();
      } else {
        this.$message.error({
          showClose: true,
          message: "搜索名称不能为数字",
          type: "success",
        });
      }
    },
    clear() {
      this.users = {};
      this.rolesData();
    },
    //角色列表请求
    async rolesData() {
      const res = await this.$axios.getListData("admin/roles", this.users);
      if ((res.code = 200)) {
        console.log(res.data);

        this.active = res.data.length ? res.data[0].id : "";
        this.permissions.id = res.data.length ? res.data[0].id : ""; //第一个角色id
        this.rolesuser.role_id = res.data.length ? res.data[0].id : ""; //默认的角色id
        this.index = res.data.length ? res.data[0].id : ""; //显示删除编辑id
        this.roleData = res.data;
        this.permissionsList();
      }
    },
    close() {
      this.modify = {};
      this.Popup = false;
    },
    handClickCancel() {
      this.Popup = false;
      this.modify = {};
    },
    handEdit(e) {
      this.$set(this.modify, "name", e.name);
      this.Popup = true;
      this.modify.id = e.id;
      this.title = "编辑角色";
      this.flag = false;
      this.show = true;
    },
    //添加角色
    handClickConfirm() {
      this.$refs.modify.validate(async (valid) => {
        if (valid) {
          const res = await this.$axios.postListData(
            "admin/roles",
            this.modify
          );
          if (res.code == 200) {
            this.rolesData();
            this.Popup = false;
          }
        }
      });
    },
    //编辑角色
    handClickfirm() {
      this.$refs.modify.validate(async (valid) => {
        if (valid) {
          const res = await this.$axios.postListData(
            "admin/update-role",
            this.modify
          );
          if (res.code == 200) {
            this.rolesData();
            this.Popup = false;
          }
        }
      });
    },
    //删除角色
    handDeta(id) {
      this.permissions.id = id;
      this.$confirm("是否删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$axios
          .getListData("admin/delete-role", this.permissions)
          .then((res) => {
            if (res.code == 200) {
              this.rolesData();
            }
          });
      });
    },
    //权限列表
    async permissionsList() {
      const res = await this.$axios.getListData(
        "admin/role-permissions",
        this.permissions
      );
      if (res.code == 200) {
        this.name = res.data.name;
        this.usenameData = res.data.users;
        this.citiesData = res.data.all_permissions;
        this.organizationData = res.data.all_permissions;

        res.data.all_permissions.forEach((m, index, value) => {
          this.listLength = value.length;
          m.cate_permissions.forEach((v, i) => {
            this.listData.push(v.id);
            if (v.selected) {
              this.checkedData.push(v.id);
            }
            if (this.name === "系统管理员") {
              this.checkedData.push(v.id);
            }
          });
        });

        if (this.checkedData.length == this.listData.length) {
          this.isIndeterminate = false;
          this.checkAllFalse = true;
        } else if (this.checkedData.length) {
          this.checkAllFalse = false;
          this.isIndeterminate = true;
        } else {
          this.checkAllFalse = false;
          this.isIndeterminate = false;
        }
        //   res.data.all_permissions.map((item) => {
        //     this.cities.push(item.id);
        //   });
        //   if (res.data.name == "系统管理员") {
        //     res.data.all_permissions.map((item) => {
        //       this.value.push(item.id);
        //     });
        //   } else {
        //     res.data.all_permissions.map((v) => {
        //       if (v.selected) {
        //         this.value.push(v.id);
        //       }
        //     });
        //     if (this.value.length == 0) {
        //       this.checkAll = false;
        //       this.isIndeterminate = false;
        //     } else if (this.value.length == this.cities.length) {
        //       this.isIndeterminate = false;
        //       this.checkAll = true;
        //     } else {
        //       this.checkAll = false;
        //       this.isIndeterminate = true;
        //     }
        //   }
      }
    },
    //角色权限列表
    async permissionsData(id) {
      this.checkedFalse =true
      this.listData = [];
      this.checkedData = []; //清空保存的选项
      // this.value = []; //清空保存的选项
      this.active = id;
      this.index = id;
      this.permissions.id = id;
      this.rolesuser.role_id = id;
      const res = await this.$axios.getListData(
        "admin/role-permissions",
        this.permissions
      );
      if (res.code == 200) {
        this.name = res.data.name;
        this.usenameData = res.data.users;
        this.citiesData = res.data.all_permissions;
        this.organizationData = res.data.all_permissions;
        res.data.all_permissions.forEach((m) => {
          m.cate_permissions.forEach((v, i) => {
            this.listData.push(v.id);
            if (this.name === "系统管理员") {
              this.checkedData.push(v.id);
            }
            if (v.selected) {
              this.checkedData.push(v.id);
            }
          });
        });

        if (this.checkedData.length == this.listData.length) {
          this.isIndeterminate = false;
          this.checkAllFalse = true;
        } else if (this.checkedData.length) {
          console.log(111);
          this.checkAllFalse = false;
          this.isIndeterminate = true;
        } else {
          console.log(111);
          this.checkAllFalse = false;
          this.isIndeterminate = false;
        }
        // this.$forceUpdate();
        // if (res.data.name == "系统管理员") {
        //   res.data.all_permissions.map((item, index, value) => {
        //     this.value.push(item.id);
        //   });
        // } else {
        //   res.data.all_permissions.map((v, index, value) => {
        //     if (v.selected) {
        //       this.value.push(v.id);
        //     }
        //     if (this.value.length == 0) {
        //       this.checkAll = false;
        //       this.isIndeterminate = false;
        //     } else if (this.value.length == this.cities.length) {
        //       this.isIndeterminate = false;
        //       this.checkAll = true;
        //     } else {
        //       this.checkAll = false;
        //       this.isIndeterminate = true;
        //     }
        //   });
        // }
      }
    },
    // async handleCheckAllChange(val) {
    //   console.log(val);
    //   this.value = val ? this.cities : [];
    //   this.isIndeterminate = false;
    //   this.rolesuser.permission_ids = this.value.join(",");
    //   const res = await this.$axios.postListData(
    //     "admin/role-permissions",
    //     this.rolesuser
    //   );
    //   if (res.code == 200) {
    //   }
    // },
    // async handleCheckedCitiesChange(val) {
    //   console.log(val);
    //   this.checkAll = val.length === this.cities.length;
    //   this.isIndeterminate = val.length > 0 && val.length < this.cities.length;
    //   // this.rolesuser.permission_ids = ""
    //   this.rolesuser.permission_ids = val.join(",");
    //   const res = await this.$axios.postListData(
    //     "admin/role-permissions",
    //     this.rolesuser
    //   );
    //   if (res.code == 200) {
    //   }
    // },
    //
  },
};
</script>
<style lang="less" scoped>
.dialog-footer {
  display: flex !important;
  justify-content: space-around !important;
}
// /deep/.el-checkbox__label {
//   font-size: 20px;
// }
// // /deep/.el-checkbox__inner {
//   width: 20px;
//   height: 20px;
// }
// /deep/.el-checkbox__inner::after {
//   height: 12px !important;
//   left: 7px !important;
// }
/deep/.el-tree {
  display: flex;
  flex-wrap: wrap;
  // width: 1000px;
}
/deep/.el-checkbox__label {
  font-size: 18px;
}
/deep/.el-tree-node {
  margin: 10px 20px;
}
.container {
  width: 100%;
  box-sizing: border-box;
  padding: 12px 22px;
  overflow: hidden;
  display: flex;
  .usename {
    margin: 10px 0;
    display: inline-block;
    padding: 2px 8px;
    border-radius: 20px;
    background-color: #f2f3f6;
    margin-right: 12px;
    margin-bottom: 12px;
    white-space: nowrap;
  }
  .content {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
  }
  .margin {
    margin: 15px 0;
  }
  .width {
    width: 90%;
  }
  .distance {
    margin: 10px 0;
  }

  .distance-left {
    padding: 15px;
    width: 200px;
    box-sizing: border-box;
  }
  .left {
    width: 18%;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-end;
    .scroll {
      overflow-y: auto;
      height: 676px;
    }
    .plus {
      margin-left: 15px;
      padding: 10px;
      box-sizing: border-box;
      width: 100%;

      .list {
        margin: 20px 0;
        width: 90%;
        display: flex;
        justify-content: space-between;
      }
      .iconnfon {
        background-color: #409eff;
      }

      .background {
        background-color: rgba(34, 73, 192, 0.06);
      }
      .iocn {
        padding: 10px;
        box-sizing: border-box;
        border-radius: 0 4px 0 4px;
        margin: 10px 0;
        width: 90%;
        display: flex;
        justify-content: space-between;
        align-content: center;
        .list-left {
          padding-left: 10px;
        }
      }
    }

    .br {
      height: calc(100vh - 162px);
      border-left: 1px solid #e6e7ec;
    }
  }

  .right {
    width: 82%;
    padding: 0 20px;
    .flex {
      display: flex;
      // justify-content: space-between;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
    }
    .list {
      // width: 500px;
      overflow: hidden;
    }
  }
}
</style>

